import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { NgClass, NgIf } from '@angular/common'
import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'table-list-select-new',
  imports: [
    MatTableModule,
    MatIconModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    NgClass,
  ],
  templateUrl: './table-list-select-new.component.html',
  styleUrl: './table-list-select-new.component.scss',
})
export class TableListSelectNewComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Output() selectItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Input() listSelected: any[] = []
  @Input() selected: any = {}
  @Input() multiSelect = false

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  checkSelect(element: any) {
    if (element.id && element) {
      if (this.multiSelect) {
        const index = this.listSelected.findIndex((item) => item.id == element.id)
        return index == -1 ? false : true
      } else {
        return element.id == this.selected.id ? true : false
      }
    }
    return false
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }
}
